/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Advanced configuration options for RDS Native PITR restore.
*/
export class RdsNativePitrAdvancedConfig {
  /**
  * Enable IAM database authentication for the restored database.
  */
  'isIamDatabaseAuthenticationEnabled'?: boolean;
  /**
  * Database port number. If not specified, uses the default port for the engine. 
  */
  'port'?: number;
  /**
  * Storage type for the database.  Valid values: - aurora: Aurora standard storage (Aurora clusters only) - aurora-iopt1: Aurora optimized I/O (Aurora clusters only) - io1: Provisioned IOPS SSD - gp2: General Purpose SSD - gp3: General Purpose SSD (latest generation) 
  */
  'storageType'?: string;
  /**
  * Enable deletion protection to prevent accidental database deletion. Recommended for production environments. 
  */
  'isDeletionProtectionEnabled'?: boolean;
  /**
  * CloudWatch log types to enable. - For Aurora MySQL: audit, error, general, slowquery - For Aurora PostgreSQL: postgresql - For RDS MySQL: error, general, slowquery - For RDS PostgreSQL: postgresql 
  */
  'cloudwatchLogExportTypes'?: Array<string>;
  /**
  * Copy database tags to automated backup snapshots.
  */
  'isCopyTagsToSnapshotEnabled'?: boolean;
  /**
  * Automatically upgrade to new minor engine versions during maintenance windows. Note: Cannot be applied during restore via AWS API, only after. 
  */
  'isAutoMinorVersionUpgradeEnabled'?: boolean;
  /**
  * Network type for the database.  Valid values: - IPV4: IPv4 only (default) - DUAL: Both IPv4 and IPv6 
  */
  'networkType'?: string;
  /**
  * Active Directory domain for Windows Authentication. Only for PostgreSQL with Kerberos authentication. 
  */
  'domain'?: string;
  /**
  * IAM role name for Active Directory domain authentication. Required if domain is specified. 
  */
  'domainIamRoleName'?: string;
  /**
  * DB option group to associate with the restored database. Aurora MySQL and RDS MySQL only (not applicable to PostgreSQL). 
  */
  'optionGroupName'?: string;
  /**
  * Restore to the latest available point in time instead of a specific time. Either restoreToTime or isRestoreToLatest must be specified (not both). Useful when you want the most recent data available. 
  */
  'isRestoreToLatest'?: boolean;
  /**
  * Provisioned IOPS for io1 storage type. Required if storageType is io1. Must be multiple between 0.5 and 50 of storage amount. 
  */
  'iops'?: number;
  /**
  * Custom tags to apply to the restored database (instance or cluster). **Example:** `{\"eon_api_restore\": \"true\"}` 
  */
  'tags'?: { [key: string]: string; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "isIamDatabaseAuthenticationEnabled",
      "baseName": "isIamDatabaseAuthenticationEnabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "port",
      "baseName": "port",
      "type": "number",
      "format": ""
    },
    {
      "name": "storageType",
      "baseName": "storageType",
      "type": "string",
      "format": ""
    },
    {
      "name": "isDeletionProtectionEnabled",
      "baseName": "isDeletionProtectionEnabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "cloudwatchLogExportTypes",
      "baseName": "cloudwatchLogExportTypes",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "isCopyTagsToSnapshotEnabled",
      "baseName": "isCopyTagsToSnapshotEnabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "isAutoMinorVersionUpgradeEnabled",
      "baseName": "isAutoMinorVersionUpgradeEnabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "networkType",
      "baseName": "networkType",
      "type": "string",
      "format": ""
    },
    {
      "name": "domain",
      "baseName": "domain",
      "type": "string",
      "format": ""
    },
    {
      "name": "domainIamRoleName",
      "baseName": "domainIamRoleName",
      "type": "string",
      "format": ""
    },
    {
      "name": "optionGroupName",
      "baseName": "optionGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "isRestoreToLatest",
      "baseName": "isRestoreToLatest",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "iops",
      "baseName": "iops",
      "type": "number",
      "format": "int32"
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RdsNativePitrAdvancedConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

